import React from 'react';
import { Receipt } from 'lucide-react';
import { TabInvoices } from './Billing';

// Standalone page for the invoice register. It used to be a tab inside Billing,
// where taking a payment was hard to find — Receive Payment is now the front
// door for money coming in, and this is the register you consult.
export default function Invoices() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Receipt size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Invoices</h1>
          <p className="text-xs text-gray-400">Every invoice — create, view, credit or cancel</p>
        </div>
      </div>
      <TabInvoices />
    </div>
  );
}
